import { useQuery, useQueryClient } from "@tanstack/react-query";

import { referralApiClient } from "@/libs/api";

// Query keys for consistent cache management
export const referralKeys = {
  all: ["referral"] as const,
  stats: () => [...referralKeys.all, "stats"] as const
};

interface UseReferralStatsOptions {
  orgId?: string;
  enabled?: boolean;
}

export function useReferralStats(options: UseReferralStatsOptions = {}) {
  const { enabled = true, orgId = undefined } = options;

  return useQuery({
    queryKey: referralKeys.stats(),
    queryFn: async () => {
      return referralApiClient.getStats(orgId);
    },
    enabled,
    staleTime: 10 * 60 * 1000 // 10 minutes for referral stats
  });
}

// Utility hook for invalidating referral cache
export function useReferralInvalidation() {
  const queryClient = useQueryClient();

  return {
    invalidateAll: () => queryClient.invalidateQueries({ queryKey: referralKeys.all }),
    invalidateStats: () => queryClient.invalidateQueries({ queryKey: referralKeys.stats() })
  };
}
